import { FormResponse, Section } from "@/types/form";
import responses from "./formResponses.json";
import sections from "./questions.json";

export function getFormResponses(): FormResponse[] {
  return responses as FormResponse[];
}

export function getQuestions(): Section[] {
  return sections as Section[];
}
